import IconChevronLeftSolid from '@/assets/icons/font_awesome/chevron-left-solid.svg?react';
import IconChevronRightSolid from '@/assets/icons/font_awesome/chevron-right-solid.svg?react';
import IconCoinsSolid from '@/assets/icons/font_awesome/coins-solid.svg?react';
import IconPercentSolid from '@/assets/icons/font_awesome/percent-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_workspace_billing } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EMonth } from '../../credits_transactions/_base/EMonth';
import { WSTableCreditsStatisticsHeader } from './WSTableCreditsStatisticsHeader';
import { WSTableCreditsStatisticsRow } from './WSTableCreditsStatisticsRow';

export function WSTableCreditsStatistics() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { credit_transactions_map } = use_slice_workspace_billing(['credit_transactions_map']);

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [isCoins, setIsCoins] = useState(true);

  function render_rows() {
    let credits_per_year = Array.from(credit_transactions_map.values().flatMap(inner_map => inner_map.values())).filter(
      item => new Date(item.created_at).getFullYear() === currentYear,
    );

    if (credits_per_year.length === 0) return <TABLE__empty />;

    return (
      <div className="flex flex-col justify-start items-center h-full w-full">
        {Object.values(EMonth).map((item, index) => (
          <WSTableCreditsStatisticsRow key={`${item}_${index}`} month={item} year={currentYear} is_coins={isCoins} />
        ))}
      </div>
    );
  }

  return (
    <div className="w-full h-full min-h-[48.25rem]">
      <div
        className={`${md(
          'h-full w-full overflow-auto',
          ' pt-2 ',
        )} mt-3 flex flex-col justify-center items-start border-b border-component-border text-page-foreground`}
      >
        <div className="text-xl">
          <UI_PRIMITIVE__button_with_icon_animated
            className="p-0 mr-2"
            iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
            iconClassNameHovered="!text-bar-foreground"
            variant="no-border-on-component"
            Icon={isCoins ? IconCoinsSolid : IconPercentSolid}
            onClick={() => setIsCoins(!isCoins)}
            renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
          />
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_statistic_monthly.title)}
        </div>
        <div className={`${md('px-2 justify-start gap-2', 'pr-5 justify-start')} w-full min-h-[50px] flex flex-row items-center mt-2`}>
          <span className={`${md('min-w-[130px] text-[10px]', 'min-w-[220px]')} text-left flex items-center`}>
            <div className="flex items-center justify-center">
              <UI_PRIMITIVE__button_with_icon_animated
                renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
                className="p-0"
                iconClassNameBase="!text-component-item-foreground !w-3 !h-3"
                iconClassNameHovered="!text-bar-foreground"
                variant={'no-border-on-component'}
                Icon={IconChevronLeftSolid}
                onClick={() => setCurrentYear(currentYear - 1)}
              />
              <span className="w-[50px] text-center">{currentYear}</span>
              <UI_PRIMITIVE__button_with_icon_animated
                renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
                className="p-0"
                iconClassNameBase="!text-component-item-foreground !w-3 !h-3"
                iconClassNameHovered="!text-bar-foreground"
                variant={'no-border-on-component'}
                Icon={IconChevronRightSolid}
                onClick={() => setCurrentYear(currentYear + 1)}
              />
            </div>
          </span>
          <WSTableCreditsStatisticsHeader />
        </div>

        <div className="w-full border-t border-component-item" />

        {render_rows()}
      </div>
    </div>
  );
}
